module.exports = __webpack_public_path__ + "img/02.bf7afde7.jpg";